import React from "react";
import DialogFooterCusBtn from "./DialogFooterCusBtn";
import DialogHeader from "./footer/DialogHeader";
import DialogOnlyWrapper from "./DialogOnlyWrapper";

interface DialogsmallProps {
  isOpen: boolean;
  handleHeaderClose: () => void;
  handleClose?: () => void;
  handleFooterSubmit?: () => void;
  children: React.ReactNode;
  title: string;
  subtitle: string;
  cancel?: string;
  submit: string;
  type?: "button" | "submit";
  buttonloading?: boolean;
  submitDisabled?: boolean;
  requiredMessage?: string;
  userRoll?: string;
  userStatus?: string;
  handleSuspend?: () => void;
  handleDelete?: () => void;
  handleAcitiveUsers?: () => void;
  hideFooter?: boolean; // <-- new prop
}

const DialogManageUser: React.FC<DialogsmallProps> = ({
  isOpen,
  handleClose,
  handleHeaderClose,
  handleFooterSubmit,
  children,
  title,
  subtitle,
  cancel,
  submit,
  type,
  buttonloading,
  submitDisabled,
  requiredMessage,
  userRoll,
  userStatus,
  handleSuspend,
  handleDelete,
  handleAcitiveUsers,
  hideFooter = false, // default false
}) => {
  const isSuccessScreen =
    React.isValidElement(children) &&
    children.type &&
    (children.type as any).name === "RequestToPaySuccess";

  if (!isOpen) return null;

  return (
    <DialogOnlyWrapper>
      <div className="gx-dialog-box">
        <DialogHeader
          handleClose={handleHeaderClose}
          title={title}
          subtitle={subtitle}
        />
        <div className="gx-dialog-main">{children}</div>

        {!isSuccessScreen && !hideFooter && (
          <DialogFooterCusBtn
            handleClose={handleClose}
            handleFooterSubmit={handleFooterSubmit}
            cancel={cancel}
            submit={submit}
            type={type}
            buttonbaseRole={userRoll}
            baseStatus={userStatus}
            handleSuspend={handleSuspend}
            handleDelete={handleDelete}
            buttonloading={buttonloading}
            submitDisabled={submitDisabled}
            requiredMessage={requiredMessage}
            handleActivateUser={handleAcitiveUsers}
          />
        )}
      </div>
    </DialogOnlyWrapper>
  );
};

export default DialogManageUser;
